import axios from "axios";

// const instance = axios.create({
//   baseURL: "http://192.168.0.113:5000/api", // 👈 your backend base URL
//   withCredentials: true, // important for cookies/auth
// });
const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_DOMAIN,
    withCredentials: true,
  });

export default instance;
